var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" Card "),(this.client.key)?_c('card-form',{attrs:{"client":_vm.client},on:{"result":_vm.processResult}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }